import { get, put,Delete,post } from '../axios'

// 分组管理-列表
export const gatewayList = params => get(`/web/user/gateway/list`,params);

// 分组管理-删除
export const gatewayDelete = params => Delete('/web/user/gateway/delete/' + params.id, '');

// 分组管理-批量删除
export const gatewayDeletes = params => Delete('/web/user/gateway/deletes/' + params.id, '')

// 分组管理-编辑
export const gatewayUpdate = params => put(`/web/user/gateway/update`,params);

//网关管理-成员列表
export const gatewayUserList = params => get('/web/user/gateway/user/list', params);

//网关管理-重新生成二维码
export const gatewayRecreateCodeImage = params => post('/web/user/gateway/codeImage/recreate/' + params.id);



